<template>
    <component :is="activePopup.attributes.vueComponent" if="activePopup"
        :popup-data="activePopup" @popup-closed="emitPopupClosed"/>
</template>

<script>
    import Container from '@services/Container';

    const container = Container.getInstance();
    const userPreferencesRepository = container.getUserPreferenceRepository();

    export default {
        props: {
            popups: {
                type: Array,
                required: true,
            },
        },
        emits: ['popup-closed'],
        computed: {
            activePopup() {
                if (this.popups.length) {
                    return this.popups[0];
                }
                return null;
            },
        },
        mounted() {
            if (!this.activePopup) {
                return;
            }
            this.countPopupDisplay();
        },
        methods: {
            countPopupDisplay() {
                userPreferencesRepository.countPopupDisplay(this.activePopup.id);
            },
            emitPopupClosed() {
                this.$emit('popup-closed');
            },
        },
    }
</script>
